import { ResponsiveBar } from '@nivo/bar';
import React from 'react';

const MyResponsiveBar = ({ data, currency }) => (
  <ResponsiveBar
    data={data}
    keys={['total_sales']}
    indexBy="month_name"
    margin={{ top: 20, right: 20, bottom: 50, left: 75 }}
    padding={0.3}
    valueScale={{ type: 'linear' }}
    indexScale={{ type: 'band', round: true }}
    // colors={{ scheme: 'nivo' }}
    // colors="#07efb8"
    colors="#989797"
    theme={{
      fontSize: 10,
      textColor: '#000',
      labels: {
        text: {
          fontWeight: 'bolder'
        }
      },
      axis: {
        legend: {
          text: {
            fontSize: 20,
            fontWeight: 'bold',
            fill: '#000000'
          }
        }
      },
      legends: {
        title: {
          text: {
            fontSize: 18,
            fontWeight: 'bold',
            fill: '#000000'
          }
        },
        text: {
          fontSize: 18,
          fontWeight: 'bold',
          fill: '#000000'
        },
        ticks: {
          line: {},
          text: {
            fontSize: 12,
            fontWeight: 'bold',
            fill: '#000000'
          }
        }
      }
    }}
    defs={[
      {
        id: 'dots',
        type: 'patternDots',
        background: 'inherit',
        color: '#38bcb2',
        size: 4,
        padding: 1,
        stagger: true
      },
      {
        id: 'lines',
        type: 'patternLines',
        background: 'inherit',
        color: '#eed312',
        rotation: -45,
        lineWidth: 6,
        spacing: 10
      }
    ]}
    borderColor={{
      from: 'color',
      modifiers: [['darker', 1.6]]
    }}
    axisTop={null}
    axisRight={null}
    axisBottom={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: -45,
      legend: 'Month',
      legendPosition: 'middle',
      legendOffset: 32
    }}
    axisLeft={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: `Total Sales (${currency})`,
      legendPosition: 'middle',
      legendOffset: -67
    }}
    labelSkipWidth={12}
    labelSkipHeight={12}
    labelTextColor={{
      from: 'color',
      modifiers: [['darker', 1.6]]
    }}
    role="application"
    ariaLabel="Monthly Sales"
    barAriaLabel={(e) => `${e.id}: ${e.formattedValue} in month: ${e.indexValue}`}
  />
);

export default MyResponsiveBar;
